import { useCities } from "@/common/hooks/queries/useCities";
import useDebounce from "@/common/hooks/useDebounce";
import { GeoTransformers } from "@/common/services/geoTransformers";
import { Mapper } from "@/common/services/mapper";
import { DashboardFilterProps, DashboardFilters } from "@/features/company/types/dashboards/dashboard.type";
import DashboardFilterBadge from "../DashboardFilterBadge";

const DashboardFilterCityBadge = ({ filters, setFilters }: DashboardFilterProps) => {
  const [search, setSearch] = useDebounce('');

  const {
    data: cityOptions,
  } = useCities({
    filters: {
      search,
    },
    mapper: Mapper.mapWithTransformer({
      transformer: GeoTransformers.optionsTransformer()
    }),
  });

  return (
    <DashboardFilterBadge
      filterKey={DashboardFilters.City}
      options={cityOptions}
      filters={filters}
      setFilters={setFilters}
      setSearch={setSearch}
    />
  );
}

export default DashboardFilterCityBadge;
